import SingleSelectCommonComponentView from '../../../components/common/single-select-common-component.view';
export default function WorkTemplateTimePickerView() {

    let items = [];
    let onChanged = () => { }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.onChanged) {
                onChanged = vnode.attrs.onChanged;
            }
        },
        view: (vnode) => {
            items = [];
            if (vnode.attrs.pickerType == "hour") {
                for (let i = 0; i < 24; i++) {
                    items.push({ code: i.toString().length == 1 ? "0" + i : i.toString(), name: i.toString().length == 1 ? "0" + i : i.toString() });
                }
            } else {
                for (let i = 0; i < 60; i++) {
                    items.push({ code: i.toString().length == 1 ? "0" + i : i.toString(), name: i.toString().length == 1 ? "0" + i : i.toString() });
                }
            }

            return [
                m(SingleSelectCommonComponentView, {
                    iconList: [], items: items, selectedItem: vnode.attrs.selectedItem, disabled: vnode.attrs.disabled, handleSelect: (selectedCode) => {
                        onChanged(selectedCode);
                    }
                })
            ]
        }
    }
}
